import { LocaleEnum } from '@amzn/fire-tv-campaign-automation-service';

export enum CTA {
  // English (US) CTAs
  EN_US_NEXT_UP_FOR_YOU_FROM_FIRE_TV = 'Next Up For You from Fire TV',
  EN_US_PLAY_NOW = 'Play now',
  EN_US_RECOMMENDED_FOR_YOU = 'Recommended for you',
  EN_US_STREAM_NOW = 'Stream now',
  EN_US_WATCH_FREE = 'Watch free',
  EN_US_WATCH_FREE_ON = 'Watch free on',
  EN_US_WATCH_LIVE = 'Watch live',
  EN_US_WATCH_NOW = 'Watch now',
  EN_US_REMIND_ME = 'Remind me',

  // English (Canada) CTAs
  EN_CA_PLAY_NOW = 'Play now',
  EN_CA_RECOMMENDED_FOR_YOU = 'Recommended for you',
  EN_CA_STREAM_NOW = 'Stream now',
  EN_CA_WATCH_FREE = 'Watch free',
  EN_CA_WATCH_FREE_ON = 'Watch free on',
  EN_CA_WATCH_LIVE = 'Watch live',
  EN_CA_WATCH_NOW = 'Watch now',

  // English (GB) CTAs
  EN_GB_PLAY_NOW = 'Play now',
  EN_GB_RECOMMENDED_FOR_YOU = 'Recommended for you',
  EN_GB_STREAM_NOW = 'Stream now',
  EN_GB_WATCH_FREE = 'Watch free',
  EN_GB_WATCH_FREE_ON = 'Watch free on',
  EN_GB_WATCH_LIVE = 'Watch live',
  EN_GB_WATCH_NOW = 'Watch now',
  EN_GB_EXPLORE_MORE = 'Explore more',
  EN_GB_DISCOVER_MORE = 'Discover more',
  EN_GB_LEARN_MORE = 'Learn more',
  EN_GB_OPEN_THE_APP = 'Open the app',
  EN_GB_START_TRIAL = 'Start trial',
  EN_GB_TRY_FOR_FREE = 'Try for free',
  EN_GB_AVAILABLE_NOW = 'Available now',
  EN_GB_PRESS_PLAY = 'Press play',

  // English (India) CTAs
  EN_IN_PLAY_NOW = 'Play now',
  EN_IN_RECOMMENDED_FOR_YOU = 'Recommended for you',
  EN_IN_STREAM_NOW = 'Stream now',
  EN_IN_WATCH_FREE = 'Watch free',
  EN_IN_WATCH_FREE_ON = 'Watch free on',
  EN_IN_WATCH_LIVE = 'Watch live',
  EN_IN_WATCH_NOW = 'Watch now',
  EN_IN_EXPLORE_MORE = 'Explore more',
  EN_IN_DISCOVER_MORE = 'Discover more',
  EN_IN_LEARN_MORE = 'Learn more',
  EN_IN_OPEN_THE_APP = 'Open the app',
  EN_IN_START_TRIAL = 'Start trial',
  EN_IN_TRY_FOR_FREE = 'Try for free',
  EN_IN_AVAILABLE_NOW = 'Available now',

  // English (Australia) CTAs
  EN_AU_PLAY_NOW = 'Play now',
  EN_AU_RECOMMENDED_FOR_YOU = 'Recommended for you',
  EN_AU_STREAM_NOW = 'Stream now',
  EN_AU_WATCH_FREE = 'Watch free',
  EN_AU_WATCH_FREE_ON = 'Watch free on',
  EN_AU_WATCH_LIVE = 'Watch live',
  EN_AU_WATCH_NOW = 'Watch now',

  // Spanish (US) CTAs
  ES_US_PLAY_NOW = 'Jugar ahora',
  ES_US_RECOMMENDED_FOR_YOU = 'Recomendado para ti',
  ES_US_STREAM_NOW = 'Reproducir ahora',
  ES_US_WATCH_NOW = 'Ver ahora',
  ES_US_WATCH_FREE = 'Ver gratis',
  ES_US_WATCH_FREE_ON = 'Ver gratis en',
  ES_US_WATCH_LIVE = 'Ver en directo',

  // Spanish (Mexico) CTAs
  ES_MX_PLAY_NOW = 'Jugar ahora',
  ES_MX_RECOMMENDED_FOR_YOU = 'Recomendado para ti',
  ES_MX_STREAM_NOW = 'Reproducir ahora',
  ES_MX_WATCH_NOW = 'Ver ahora',
  ES_MX_WATCH_FREE = 'Ver gratis',
  ES_MX_WATCH_FREE_ON = 'Ver gratis en',
  ES_MX_WATCH_LIVE = 'Ver en directo',

  // Spanish (Spain) CTAs
  ES_ES_PLAY_NOW = 'Jugar ahora',
  ES_ES_RECOMMENDED_FOR_YOU = 'Recomendado para ti',
  ES_ES_STREAM_NOW = 'Reproducir ahora',
  ES_ES_WATCH_FREE = 'Ver gratis',
  ES_ES_WATCH_FREE_ON = 'Ver gratis en',
  ES_ES_WATCH_LIVE = 'Ver en directo',
  ES_ES_WATCH_NOW = 'Ver ahora',
  ES_ES_EXPLORE_MORE = 'Explora más',
  ES_ES_DISCOVER_MORE = 'Descubre más',
  ES_ES_LEARN_MORE = 'Más información',
  ES_ES_OPEN_THE_APP = 'Abrir la aplicación',
  ES_ES_START_TRIAL = 'Comenzar prueba',
  ES_ES_TRY_FOR_FREE = 'Prueba gratis',
  ES_ES_AVAILABLE_NOW = 'Disponible ahora',

  // French (Canada) CTAs
  FR_CA_PLAY_NOW = 'Jouer maintenant',
  FR_CA_RECOMMENDED_FOR_YOU = 'Recommandé pour vous',
  FR_CA_STREAM_NOW = 'Diffuser maintenant',
  FR_CA_WATCH_NOW = 'Regarder maintenant',
  FR_CA_WATCH_FREE = 'Regarder gratuitement',
  FR_CA_WATCH_FREE_ON = 'Regarder gratuitement sur',
  FR_CA_WATCH_LIVE = 'Regarder en direct',

  // French (France) CTAs
  FR_FR_PLAY_NOW = 'Jouer',
  FR_FR_RECOMMENDED_FOR_YOU = 'Recommandé pour vous',
  FR_FR_WATCH_NOW = 'Regarder',
  FR_FR_WATCH_FREE = 'Regarder gratuitement',
  FR_FR_WATCH_FREE_ON = 'Regarder gratuitement sur',
  FR_FR_WATCH_LIVE = 'En direct',
  FR_FR_EXPLORE_MORE = 'Explorer',
  FR_FR_DISCOVER_MORE = 'En savoir plus',
  FR_FR_LEARN_MORE = 'En savoir plus',
  FR_FR_OPEN_THE_APP = "Ouvrir l'application",
  FR_FR_START_TRIAL = "Commencer l'essai",
  FR_FR_TRY_FOR_FREE = 'Essayer gratuitement',
  FR_FR_AVAILABLE_NOW = 'Disponible',

  // German CTAs
  DE_DE_PLAY_NOW = 'Jetzt spielen',
  DE_DE_RECOMMENDED_FOR_YOU = 'Für dich empfohlen',
  DE_DE_STREAM_NOW = 'Jetzt streamen',
  DE_DE_WATCH_FREE = 'Jetzt schauen',
  DE_DE_WATCH_FREE_ON = 'Kostenlos anschauen',
  DE_DE_WATCH_LIVE = 'Live schauen',

  // Italian CTAs
  IT_IT_PLAY_NOW = 'Gioca ora',
  IT_IT_RECOMMENDED_FOR_YOU = 'Scelti per te',
  IT_IT_STREAM_NOW = 'Guarda in streaming',
  IT_IT_WATCH_FREE = 'Guarda gratis',
  IT_IT_WATCH_FREE_ON = 'Guarda gratis su',
  IT_IT_WATCH_LIVE = 'Guarda in diretta',
  IT_IT_WATCH_NOW = 'Guarda ora',
  IT_IT_EXPLORE_MORE = 'Esplora',
  IT_IT_DISCOVER_MORE = 'Scopri di più',
  IT_IT_LEARN_MORE = 'Scopri di più',
  IT_IT_OPEN_THE_APP = "Apri l'app",
  IT_IT_START_TRIAL = 'Inizia la prova',
  IT_IT_TRY_FOR_FREE = 'Prova gratis',
  IT_IT_AVAILABLE_NOW = 'Disponibile ora',

  // Japanese CTAs
  JA_JP_PLAY_NOW = '今すぐ観る',
  JA_JP_RECOMMENDED_FOR_YOU = 'あなたにオススメ',
  JA_JP_STREAM_NOW = '続きを観る',
  JA_JP_WATCH_FREE = '無料で観る',
  JA_JP_WATCH_LIVE = 'ライブで観る',
  JA_JP_LEARN_MORE = 'もっと詳しく',
  JA_JP_OPEN_THE_APP = 'アプリを開く',
  JA_JP_START_TRIAL = '無料体験を開始',
  JA_JP_TRY_FOR_FREE = '無料で試す',
  JA_JP_AVAILABLE_NOW = '配信スタート',
  JA_JP_APPS_AVAILABLE_HERE = '視聴可能アプリはこちら',
  JA_JP_EXCLUSIVE_STREAMING = '独占配信中',
  JA_JP_FREE_STREAMING_NOW = '無料配信中',
  JA_JP_CHECK_VIEWING_METHOD = '視聴方法を確認',

  // Portuguese (Brazil) CTAs
  PT_BR_PLAY_NOW = 'Assistir agora',
  PT_BR_RECOMMENDED_FOR_YOU = 'Recomendados para você',
  PT_BR_STREAM_NOW = 'Comece a assistir',
  PT_BR_WATCH_FREE = 'Assista de graça',
  PT_BR_WATCH_FREE_ON = 'Assista de graça na',
  PT_BR_WATCH_LIVE = 'Assista ao vivo',
  PT_BR_WATCH_NOW = 'Assista agora',
  PT_BR_EXPLORE = 'Explorar',
  PT_BR_DISCOVER_MORE = 'Descubra mais',
  PT_BR_LEARN_MORE = 'Saiba mais',
  PT_BR_OPEN_THE_APP = 'Abrir o app',
  PT_BR_START_TRIAL = 'Começar teste grátis',
  PT_BR_TRY_FOR_FREE = 'Experimente grátis',
  PT_BR_AVAILABLE_NOW = 'Já disponível',
}

const LOCALE_CTAS: Partial<Record<LocaleEnum, CTA[]>> = {
  [LocaleEnum.EN_US]: [
    CTA.EN_US_NEXT_UP_FOR_YOU_FROM_FIRE_TV,
    CTA.EN_US_PLAY_NOW,
    CTA.EN_US_RECOMMENDED_FOR_YOU,
    CTA.EN_US_STREAM_NOW,
    CTA.EN_US_WATCH_FREE,
    CTA.EN_US_WATCH_FREE_ON,
    CTA.EN_US_WATCH_LIVE,
    CTA.EN_US_WATCH_NOW,
    CTA.EN_US_REMIND_ME,
  ],
  [LocaleEnum.ES_US]: [
    CTA.ES_US_PLAY_NOW,
    CTA.ES_US_RECOMMENDED_FOR_YOU,
    CTA.ES_US_STREAM_NOW,
    CTA.ES_US_WATCH_NOW,
    CTA.ES_US_WATCH_FREE,
    CTA.ES_US_WATCH_FREE_ON,
    CTA.ES_US_WATCH_LIVE,
  ],
  [LocaleEnum.EN_CA]: [
    CTA.EN_CA_PLAY_NOW,
    CTA.EN_CA_RECOMMENDED_FOR_YOU,
    CTA.EN_CA_STREAM_NOW,
    CTA.EN_CA_WATCH_FREE,
    CTA.EN_CA_WATCH_FREE_ON,
    CTA.EN_CA_WATCH_LIVE,
    CTA.EN_CA_WATCH_NOW,
  ],
  [LocaleEnum.FR_CA]: [
    CTA.FR_CA_PLAY_NOW,
    CTA.FR_CA_RECOMMENDED_FOR_YOU,
    CTA.FR_CA_STREAM_NOW,
    CTA.FR_CA_WATCH_FREE,
    CTA.FR_CA_WATCH_FREE_ON,
    CTA.FR_CA_WATCH_LIVE,
    CTA.FR_CA_WATCH_NOW,
  ],
  [LocaleEnum.ES_MX]: [
    CTA.ES_MX_PLAY_NOW,
    CTA.ES_MX_RECOMMENDED_FOR_YOU,
    CTA.ES_MX_STREAM_NOW,
    CTA.ES_MX_WATCH_NOW,
    CTA.ES_MX_WATCH_FREE,
    CTA.ES_MX_WATCH_FREE_ON,
    CTA.ES_MX_WATCH_LIVE,
  ],
  [LocaleEnum.EN_GB]: [
    CTA.EN_GB_PLAY_NOW,
    CTA.EN_GB_RECOMMENDED_FOR_YOU,
    CTA.EN_GB_STREAM_NOW,
    CTA.EN_GB_WATCH_FREE,
    CTA.EN_GB_WATCH_FREE_ON,
    CTA.EN_GB_WATCH_LIVE,
    CTA.EN_GB_WATCH_NOW,
  ],
  [LocaleEnum.DE_DE]: [
    CTA.DE_DE_PLAY_NOW,
    CTA.DE_DE_RECOMMENDED_FOR_YOU,
    CTA.DE_DE_STREAM_NOW,
    CTA.DE_DE_WATCH_FREE,
    CTA.DE_DE_WATCH_FREE_ON,
    CTA.DE_DE_WATCH_LIVE,
  ],
  [LocaleEnum.FR_FR]: [
    CTA.FR_FR_PLAY_NOW,
    CTA.FR_FR_RECOMMENDED_FOR_YOU,
    CTA.FR_FR_WATCH_NOW,
    CTA.FR_FR_WATCH_FREE,
    CTA.FR_FR_WATCH_FREE_ON,
    CTA.FR_FR_WATCH_LIVE,
  ],
  [LocaleEnum.IT_IT]: [
    CTA.IT_IT_PLAY_NOW,
    CTA.IT_IT_RECOMMENDED_FOR_YOU,
    CTA.IT_IT_STREAM_NOW,
    CTA.IT_IT_WATCH_FREE,
    CTA.IT_IT_WATCH_FREE_ON,
    CTA.IT_IT_WATCH_LIVE,
    CTA.IT_IT_WATCH_NOW,
  ],
  [LocaleEnum.ES_ES]: [
    CTA.ES_ES_PLAY_NOW,
    CTA.ES_ES_RECOMMENDED_FOR_YOU,
    CTA.ES_ES_STREAM_NOW,
    CTA.ES_ES_WATCH_FREE,
    CTA.ES_ES_WATCH_FREE_ON,
    CTA.ES_ES_WATCH_LIVE,
    CTA.ES_ES_WATCH_NOW,
  ],
  [LocaleEnum.JA_JP]: [
    CTA.JA_JP_PLAY_NOW,
    CTA.JA_JP_RECOMMENDED_FOR_YOU,
    CTA.JA_JP_STREAM_NOW,
    CTA.JA_JP_WATCH_FREE,
    CTA.JA_JP_WATCH_LIVE,
  ],
  [LocaleEnum.EN_IN]: [
    CTA.EN_IN_PLAY_NOW,
    CTA.EN_IN_RECOMMENDED_FOR_YOU,
    CTA.EN_IN_STREAM_NOW,
    CTA.EN_IN_WATCH_FREE,
    CTA.EN_IN_WATCH_FREE_ON,
    CTA.EN_IN_WATCH_LIVE,
    CTA.EN_IN_WATCH_NOW,
  ],
  [LocaleEnum.EN_AU]: [
    CTA.EN_AU_PLAY_NOW,
    CTA.EN_AU_RECOMMENDED_FOR_YOU,
    CTA.EN_AU_STREAM_NOW,
    CTA.EN_AU_WATCH_FREE,
    CTA.EN_AU_WATCH_FREE_ON,
    CTA.EN_AU_WATCH_LIVE,
    CTA.EN_AU_WATCH_NOW,
  ],
  [LocaleEnum.PT_BR]: [
    CTA.PT_BR_PLAY_NOW,
    CTA.PT_BR_RECOMMENDED_FOR_YOU,
    CTA.PT_BR_STREAM_NOW,
    CTA.PT_BR_WATCH_FREE,
    CTA.PT_BR_WATCH_FREE_ON,
    CTA.PT_BR_WATCH_LIVE,
    CTA.PT_BR_WATCH_NOW,
    CTA.PT_BR_EXPLORE,
    CTA.PT_BR_DISCOVER_MORE,
    CTA.PT_BR_LEARN_MORE,
    CTA.PT_BR_OPEN_THE_APP,
    CTA.PT_BR_START_TRIAL,
    CTA.PT_BR_TRY_FOR_FREE,
    CTA.PT_BR_AVAILABLE_NOW,
  ],
};

export const getCtaOptions = (locale: LocaleEnum): CTA[] => {
  return LOCALE_CTAS[locale] || [];
};
